import { Spin, Table } from 'antd';
import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import TableActionButton from '../../ui/TableActionButton';
import Title from '../../ui/Title';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { deleteEnterpriseSubscription, fetchtEnterpriseSubscriptionList } from '../../../store/slices/enterprise-subscription-slice';
import ConfirmDialog from '../../ui/ConfirmDialog';
import TightWrapper from '../../ui/TightWrapper';
import LoadingError from '../../ui/error/LoadingError';

const EnterpriseSubscriptionTable = () => {
    const dispatch = useDispatch();
    const { isLoading, data, isError } = useSelector((state) => state.enterpriseSubscription);
    const [dataSource, setDataSource] = useState([]);

    let nullColumns = [];
    if(dataSource.length) {
      nullColumns = Object.keys(dataSource[0]).filter(key => dataSource.every(item => item[key] === null))
    }

    useEffect(() => {
      dispatch(fetchtEnterpriseSubscriptionList());
    }, []);
    
    useEffect(() => {
      if(data.length >= 0) {
        setDataSource(
          data.map((item) => ({
            ...item,
            key: item.subscription_id,
            edit_id: item.subscription_id,
            delete_id: item.subscription_id,
          }))
          );
        }
    }, [data]);
      
    const columns = [
      {
        title: 'Subscriptoin Plan ID',
        dataIndex: 'subscription_plan_id',
        key: 'subscription_plan_id',
      },
      {
        title: 'Date',
        dataIndex: 'date',
        key: 'date',
        render: (_, { date }) => date && date.split(' ')[0]
      },
      {
        title: 'Customer ID',
        dataIndex: 'customer_id',
        key: 'customer_id',
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        key: 'amount',
      },
      {
        title: 'Balance Amount',
        dataIndex: 'balance_amount',
        key: 'balance_amount',
      },
      {
        title: 'Payment Status',
        dataIndex: 'payment_status',
        key: 'payment_status',
      },
      {
          title: 'Updated On',
          dataIndex: 'addedOn',
          key: 'addedOn',
          render: (_, { addedOn }) => addedOn && addedOn.split(' ')[0]
        },
      {
        title: 'Edit',
        dataIndex: 'edit_id',
        key: 'edit_id',
        render: (_, {edit_id}) => (
          <TightWrapper>
            <Link to={`/dashboard/enterprise-subscription-form?mode=EDIT&id=${edit_id}`}>
              <TableActionButton bg='#10ac84'>Edit</TableActionButton>
            </Link>
          </TightWrapper>
        )
      },
      {
        title: 'Delete',
        dataIndex: 'delete_id',
        key: 'delete_id',
        render: (_, {delete_id}) => (
          <ConfirmDialog
              onConfirm={() => dispatch(deleteEnterpriseSubscription({ id: delete_id }))}
            >
            <TightWrapper>
              <TableActionButton bg='#ff6b6b' >Delete</TableActionButton>
            </TightWrapper>
          </ConfirmDialog>
        )
      },
    ].filter((item) => !nullColumns.includes(item.key));;

    if(isLoading) return (
      <Spin
          tip="Loading" 
          size="large" 
          className='loading-spiner'
      />
    );
    if(isError) return <LoadingError />;

    return (
        <Wrapper>
          <Title>Enterprise Subscriptions</Title>
            <div className='card'>
                <Table 
                dataSource={dataSource}
                bordered
                size='medium'
                columns={columns} 
                style={{
                    marginTop: '10px',
                    padding: 0,
                }}
                />
            </div>
        </Wrapper>
    );
}

export default EnterpriseSubscriptionTable;

const Wrapper = styled.div`
    width: 95%;
    margin: auto;
    overflow: auto;
    animation: slide-down 300ms ease-out forwards;
    p {
        color: ${({theme}) => theme.colors.primary};
    }
    .ant-table-tbody {
        border: none;
    }
    .ant-table-thead .ant-table-cell {
        background-color:  ${({theme}) => theme.colors.primary};
        color: white;
        border-radius: 0 !important;
    }
    .card {
        box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
    }
`;

